export default function initPaymentProcessor() {
  if (process.env.VITE_PAYMENT_PROCESSOR !== '2checkout') {
    (function () {
      const script = document.createElement('script');
      script.src = 'https://cdn.paddle.com/paddle/paddle.js';
      script.type = 'text/javascript';
      script.async = 'true';
      script.onload = function () {
        const rs = this.readyState;
        if (rs && rs != 'complete' && rs != 'loaded') return;
        const { Paddle } = window;
        try {
          Paddle.Setup({ vendor: Number(process.env.VITE_PADDLE_ID) });
          if (process.env.VITE_STAGE == 'staging') {
            Paddle.Environment.set('sandbox');
          }
        } catch (e) {
          console.log(`Error loading Paddle: ${e}`);
        }
      };
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
    })();
  } else {
    (function (document, src, libName, config) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      const firstScriptElement = document.getElementsByTagName('script')[0];
      script.onload = function () {
        for (const namespace in config) {
          if (config.hasOwnProperty(namespace)) {
            window[libName].setup.setConfig(namespace, config[namespace]);
          }
        }
        window[libName].register();
      };
      firstScriptElement.parentNode.insertBefore(script, firstScriptElement);
    })(
      document,
      'https://secure.avangate.com/checkout/client/twoCoInlineCart.js',
      'TwoCoInlineCart',
      {
        app: { merchant: `${process.env.VITE_MERCHANT_ID}` },
        cart: { host: 'https://secure.2checkout.com' },
      },
    );
  }
}
